module.exports = __webpack_public_path__ + "img/Wp_2058.222f0627.png";